export default __webpack_public_path__ + "static/media/LightRain.be1ca889.mp3";